import { render, staticRenderFns } from "./bca.vue?vue&type=template&id=8d815a0e&"
import script from "./bca.vue?vue&type=script&lang=js&"
export * from "./bca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports